import React from "react";
import * as Styles from "./button.styles";

interface PrimaryButtonI {
  content: any;
  onClick?: () => void;
  disabled?: boolean;
  style?: any;
  color?: string;
  type?: "button" | "submit" | "reset" | undefined;
}

export function PrimaryButton(props: PrimaryButtonI) {
  return (
    <Styles.PrimaryButton
      disabled={props.disabled}
      onClick={props.disabled ? () => {} : props.onClick}
      style={props.style}
      color={props.color}
      type={props.type ?? "button"}
    >
      {props.content}
    </Styles.PrimaryButton>
  );
}
